import { Component, HostBinding, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { TranslateModule } from "@ngx-translate/core";
import { AutofocusDirective } from "common/autofocus/autofocus.directive";

@Component({
	selector: "stages-error-popup",
	templateUrl: "./error-popup.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, AutofocusDirective],
})
export class ErrorPopupComponent {
	private dialog = inject(DialogAdapter);

	@HostBinding("class.confirm") customClass = true;

	readonly keys = input.required<{
		titleKey: string;
		message: string;
	}>();

	ok(): void {
		this.dialog.close("ok");
	}
}
